import React from 'react'
import moment from 'moment';
import { config } from './Constants';

const helpers = {    
    getProjectStatus: function (val) {
        return (val === "book" && "จอง") ||
            (val === "sign" && "ทำสัญญา") ||
            (val === "transfer" && "โอน") ||
            (val === "expire" && "หมดประกัน") ||
            (val === "insurance" && "อยู่ในประกัน") ||
            val;
    },
    getServiceStatus: function (val) {
        return (val === "close" && (<span className='text-success'>จบงาน</span>)) ||
            (val === "cancel" && (<span className='text-danger'>ยกเลิก</span>)) ||
            (val === "progress" && ('รับเรื่อง')) ||
            (val === "doing" && ('กำลังดำเนินการ')) ||
            (val === "coordinated" && (<span className='text-danger'>ประสานงานแล้ว</span>)) ||
            val;
    },
    getServiceStatus2: function(val) {
        return val == "close" && (<button style={{color:'#00A551', borderColor:'#00A551'}} className='btn-close text-center'>จบงาน</button>) || 
        val == "cancel" && (<button style={{color:'#FF5158', borderColor:'#FF5158'}} className='btn-cancelcase text-center'>ยกเลิก</button>) || 
        val == "progress" && (<button style={{color:'#F7B900', borderColor:'#F7B900'}} className='btn-progress text-center'>รับเรื่อง</button>) || 
        val == "doing" && (<button style={{color:'#FF813A', borderColor:'#FF813A'}} className='btn-progress text-center'>กำลังดำเนินการ</button>) || 
        val == "coordinated" && (<button style={{color:'#F7B900', borderColor:'#F7B900'}} className='btn-coordinated text-center'>ประสานงานแล้ว</button>) || 
        val;
    },
    getServiceStatusText: function (val) {
        return (val === "close" && "จบงาน") ||
            (val === "cancel" && "ยกเลิก") ||
            (val === "progress" && 'กำลังดำเนินการ') ||
            (val === "doing" && 'กำลังดำเนินการ') ||
            (val === "coordinated" && "ประสานงานแล้ว") ||
            (val === "coordinate" && 'รับเรื่อง') ||
            (val === "finish" && 'จบงาน') ||
            val;
    },
    getWarrantyStatus: function (val) {
        return (val === "warranty" && 'อยู่ในประกัน') ||
            (val === "expire" && 'หมดประกัน') ||
            val;
    },
    getContactChannel: function (val) {
        return (val === "cc" && "Call Center") ||
            (val === "mobile" && "Mobile Application") ||
            (val === "old" && "Old Call Center") ||
            val;
    },
    getRefType: function (val) {
        return (val === "mgm" && "Member Get Member") ||
            (val === "event" && "Event") ||
            val;
    },
    getActiveStatus: function (val) {
        return (val == 1 && "ใช้งาน") ||
            (val == 0 && "ไม่ใช้งาน") ||
            val;
    },
    getTransferStatus: function (val) {
        return (val == "success" && "แลกพ้อยท์สำเเร็จ") ||
        (val == "inprogress" && "กำลังดำเนินการ") ||
        (val == "failed" && "ไม่สำเร็จ") ||
        val;
    },
    getTransferStatusColor: function (val) {
        return (val == "success" && "#3ba080") ||
        (val == "inprogress" && "#00A3FF") ||
        (val == "failed" && "#ff5158") ||
        val;
    },
    getMemberType: function (val) {
        return (val == 'owner' && "เจ้าของบ้านโอนกรรมสิทธิ์แล้ว") ||
            (val == 'guest' && "บุคคลทั่วไป") ||
            (val == 'live' && "ผู้อาศัย") ||
            (val == 'install' && "เจ้าของบ้านรอโอนกรรมสิทธิ์") ||
            (val == 'normal' && "สมาชิกระบบทั่วไป") ||
            (val == 'social' && "สมาชิกจากโซเชียล") ||
            (val == 'renter' && "ผู้เช่า") ||
            (val == 'god' && "ผู้ดูแล property perfect") ||
            (val == 'waiting' && "รอการอนุมัติ") ||
            (val == 'notapproved' && "ไม่ผ่านการตรวจสอบ") ||
            (val == 'SNVD' && "ผู้ดูแล property perfect") ||
            (val == 'snvd' && "ผู้ดูแล property perfect") ||
            (val == 'PFADMIN' && "ผู้ดูแล property perfect") ||
            "ไม่ระบุประเภท";
    },
    getMemberType2: function (val) {
        return (val == 'เจ้าของบ้านโอนกรรมสิทธิ์แล้ว' && "owner") ||
            (val == 'บุคคลทั่วไป' && "guest") ||
            (val == 'ผู้อาศัย' && "live") ||
            (val == 'เจ้าของบ้านรอโอนกรรมสิทธิ์' && "install") ||
            (val == 'สมาชิกระบบทั่วไป' && "normal") ||
            (val == 'สมาชิกจากโซเชียล' && "social") ||
            (val == 'ผู้เช่า' && "renter") ||
            (val == "ผู้ดูแล property perfect" && "god") ||
            (val == 'รอการอนุมัติ' && "waiting") ||
            (val == 'ไม่ผ่านการตรวจสอบ' && "notapproved") ||
            (val == "ผู้ดูแล property perfect" && "SNVD") ||
            (val == "ผู้ดูแล property perfect" && "snvd") ||
            "ไม่ระบุประเภท";
    },
    getPermission: function (val) {
        return (val === "cc" && "Call Center") ||
            (val === "rep" && "แจ้งซ่อม") ||
            (val === "pay" && "Payment") ||
            (val === "dop" && "Digital Online / Presale") ||
            (val === "mp" && "Marketing Project") ||
            (val === "amp" && "Admin Marketing Project") ||
            (val === "jf" && "Juristic / Facility") ||
            (val === "su" && "Super Admin") ||
            (val === "suc" && "Super Callcenter") ||
            (val === "acc" && "Admin Callcenter") ||
            (val === "cp" && "ร้องเรียน") ||
            (val === "cm" && "Community (บริหารหมู่บ้าน)") ||
            (val === "acs" && "ฝ่ายประสานงานราชการ") ||
            (val === "hc" && "Home Care Admin Center") ||
            val;
    },
    getSLAValue: function (val) {
        return (val === 'แจ้งซ่อม' && "24 ชม.") ||
            (val === 'ร้องเรียน' && "7 วัน") ||
            (val === 'สอบถามหรือแจ้งเรื่องอื่นๆ' && "7 วัน") ||
            val;
    },
    getMailStatus: function (val) {
        return (val === 'accepted' && "รับแล้ว") ||
            (val === 'wait' && "รอรับ") ||
            (val === 'cancel' && "ยกเลิก") ||
            val;
    },
    getMailType: function (val) {
        return (val === 'parcel' && "พัสดุ") ||
            (val === 'mail' && "จดหมาย") ||
            val;
    },
    getUserOnline: function (val) {
        return (val === 1 && "online") ||
            (val === 0 && "offline") ||
            (val === undefined && "offline") ||
            val;
    },
    getPaymentType: function (val) {
        return (val === 'รอชำระ' && "waiting") ||
            (val === 'ชำระแล้ว' && "paid") ||
            (val === 'รอตรวจสอบ' && "verify") ||
            (val === 'ค้างชำระเงิน' && "overdue") ||
            (val === 'รอใบอนุญาต' && "license") ||
            (val === 'ตรวจสอบแล้ว' && "checked") ||
            val;
    },
    getPaymentTypeTh: function (val) {
        return (val === 'waiting' && "รอชำระ") ||
            (val === 'verify' && "รอตรวจสอบ") ||
            (val === 'overdue' && "ค้างชำระเงิน") ||
            (val === 'license' && "รอใบอนุญาต") ||
            (val === 'paid' && "ชำระแล้ว") ||
            (val === 'checked' && "ตรวจสอบแล้ว") ||
            val;
    },
    getHPType: function (val) {
        return (val === 'ตรวจสอบแล้ว' && "checked") ||
            (val === 'ดำเนินการอยู่' && "process") ||
            (val === 'ดำเนินการ' && "process") ||
            (val === 'รอใบอนุญาต' && "license") ||
            val;
    },
    getHPTypeTh: function (val) {
        return (val === 'checked' && "ตรวจสอบแล้ว") ||
            (val === 'process' && "ดำเนินการอยู่") ||
            (val === 'license' && "รอใบอนุญาต") ||
            val;
    },
    getSla: function (startdate, enddate, status, hrs) {
        var sla = "";
        var now_date = moment();
        var start_date = moment(startdate);
        var end_date = moment(enddate);
        const slaCal = end_date.diff(start_date, "hours")
        
        // console.log(`manually cal sla date`)
        // console.log(slaCal)

        // console.log(`hrs`, hrs)
        
        // console.log("============end_date.diff(now_date, 'hour')==========" + end_date.diff(now_date, 'hour'));
        // console.log("============end_date.diff(start_date, 'hour')==========" + end_date.diff(start_date, 'hour'));
        // console.log("============end_date.diff(now_date, 'minute')==========" + end_date.diff(now_date, 'minute'));
        /*
        var ndate = moment();

        console.log("============ndate.diff(cdate, 'hour')=========="+ndate.diff(cdate, 'hour'));
        console.log("============sla=========="+sla);
        console.log("============status=========="+status);

        if(ndate.diff(cdate, 'hour') > sla && status == "progress"){
            sla = "sla-active";
            console.log("============sla-active==========");
        }
        
        */
        if(status == "progress"){
            if(slaCal <= 24) {
            
                if(end_date.diff(now_date, 'minutes') < 30 && end_date.diff(now_date, 'minutes') > 1) {
                    sla = "sla-warning"
                }else if(end_date.diff(now_date, 'minutes') <= 1){
                    sla = "sla-active"
                }
                
            }else{
         
                if(end_date.diff(now_date, 'minutes') >= 60   && end_date.diff(now_date, 'hours') <= 24) {
                    sla = "sla-warning"
                }else if(end_date.diff(now_date, 'minutes') < 60){
                    sla = "sla-active"
                }else{
                    sla = ""
                }
            }

        }else{
            sla = ""
        }
        

        // if (status == "progress") {
        //     if (end_date.diff(start_date, 'hour') > 24) {
        //         //มากกว่า 1 วัน
        //         if (end_date.diff(now_date, 'hour') <= 24 && end_date.diff(now_date, 'hour') > 0) {
        //             sla = "sla-warning";
        //             console.log("============sla-warning==========");
        //         } else if (end_date.diff(now_date, 'hour') < 0) {
        //             sla = "sla-active";
        //             console.log("============sla-active==========");
        //         }
        //     } else {
        //         if (end_date.diff(now_date, 'minute') <= 30 && end_date.diff(now_date, 'minute') > 0) {
        //             //24 ชั่วโมง
        //             sla = "sla-warning";
        //             console.log("============sla-warning==========");
        //         } else if (end_date.diff(now_date, 'minute') < 0) {
        //             sla = "sla-active";
        //             console.log("============sla-active==========");
        //         }
        //     }
        // }
        return sla;

    },
    getUserType: function (array, value) {
        console.log("==============================***===============" + JSON.stringify(array))
        var chk = false;
        array.map(object => {
            if (object.user_type === value) {
                chk = true
            }
        }
        );
        return chk;
    }, paymentType: function (val) {
        return (val === "waiting" && "สั่งสร้าง" || val === "finish" && "สร้างเสร็จ");
    }, checklogin: function (jwt) {
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': jwt,
            },
        };

        fetch(config.url.API_URL + '/checklogin', requestOptions)
            .then(res => {
                console.log("==================res.status=====================" + res.status)
                if (res.status === 401) {
                    localStorage.removeItem('currentUser');
                    window.location.reload();
                }
            });
    },
    formatNumber: (num) => {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    removeFormatNumber: (num) => {
        return num.toString().replace(/,/g, '') 
    }

}

export default helpers;